import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import 'bootstrap/dist/css/bootstrap.min.css';

import canadaIcon from 'assets/images/canada.png';
import usaIcon from 'assets/images/usa.png';

const StyledRoot = styled.div`
  display: flex;
`;

const StyledDropdownButton = styled(DropdownButton)`
  img {
    margin-right: 4px;
  }

  .btn-primary {
    background: none !important;
    border: none !important;
    color: ${(props) => props.theme.colors.textDark} !important;
  }

  .dropdown-menu {
    min-width: unset;
  }
`;

const FRENCH_LANGUAGE_NAME = 'Français';
const SPANISH_LANGUAGE_NAME = 'Español';
const ENGLISH_LANGUAGE_NAME = 'English';

const SUPPORTED_LANGUAGES = ['en', 'fr', 'es'];

export const getLanguageData = (localeCode: string) => {
  const languageCode = localeCode.slice(0, 2);
  switch (languageCode) {
    case 'es':
      return { code: localeCode, name: SPANISH_LANGUAGE_NAME, icon: usaIcon };
    case 'fr':
      return { code: localeCode, name: FRENCH_LANGUAGE_NAME, icon: canadaIcon };
    default:
      return { code: localeCode, name: ENGLISH_LANGUAGE_NAME, icon: usaIcon };
  }
};

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getLanguageData(i18n.language);
  const languageOptions = SUPPORTED_LANGUAGES.filter(
    (code) => code !== i18n.language
  );
  return (
    <StyledRoot>
      <StyledDropdownButton
        title={
          <>
            <img alt={currentLanguage.name} src={currentLanguage.icon} />
            <u>{currentLanguage.name}</u>
          </>
        }
      >
        {languageOptions.map((localeCode) => {
          const { code, name, icon } = getLanguageData(localeCode);
          return (
            <Dropdown.Item
              key={`language-option-${code}`}
              onClick={() => i18n.changeLanguage(code)}
              value={code}
            >
              <img alt={name} src={icon} />
              <u>{name}</u>
            </Dropdown.Item>
          );
        })}
      </StyledDropdownButton>
    </StyledRoot>
  );
};

export default LanguageSelector;
